// Primer import a propósito: instala el token de impersonación desde la URL en
// localStorage ANTES de que configureStore cargue los reducers, que leen el
// token al importarse. Ver src/bootstrapImpersonation.js.
import "./bootstrapImpersonation";

import React from "react";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { Router } from "react-router-dom";
import ReactDOM from "react-dom";
import theme from "@worcket/common/theme/variables.json";

import configureStore from "./store/configureStore";
import i18n from "./i18n";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";
import history from "./history";
import App from "./components/App";

import "moment/locale/es";
import "moment/locale/pt";
import "moment/locale/fr";

import { ThemeProvider } from "styled-components/macro";

import "./index.css";

window.WORCKET_VERSION =
  process.env.REACT_APP_LAST_COMMIT_SHA ||
  process.env.REACT_APP_WORCKET_VERSION;

const store = configureStore();

function renderApp() {
  ReactDOM.render(
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider theme={theme}>
          <Router history={history}>
            <App />
          </Router>
        </ThemeProvider>
      </I18nextProvider>
    </Provider>,
    document.getElementById("root")
  );
}

if (module.hot) {
  module.hot.accept("./components/App", renderApp);
}

unregisterServiceWorker();
renderApp();
